import React, { Component, Fragment } from 'react'
import { StyleSheet, css } from 'aphrodite'

import { AppTheme } from '../styles/AppTheme'
import { CustomMessageDialogStyles } from '../styles/CustomStyles'
import { AppConfig } from '../AppConfig'

export class SubtaskImagePreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentIndex: 0
    }
  }

  handleNextImage = () => {
    if (this.state.currentIndex < this.props.ads.length - 1) {
      this.setState((prevState) => ({ currentIndex: prevState.currentIndex + 1 }))
    }
  }

  handlePrevImage = () => {
    if (this.state.currentIndex > 0) {
      this.setState((prevState) => ({ currentIndex: prevState.currentIndex - 1 }))
    }
  }

  render() {
    const { ads } = this.props
    const { currentIndex } = this.state

    return (
      <div className={css(Styles.modalContent)}>
        <div className={css(Styles.mediaContainer)}>
          <img
            src={ads[currentIndex]}
            alt={`Ad ${currentIndex + 1}`}
            className={css(Styles.contentImage)}
          />
        </div>
        <div className={css(Styles.navigation)}>
          <span onClick={this.handlePrevImage} className={css([Styles.navButton, (currentIndex === 0) ? Styles.iconDisabled : ''])}>
            <i className='material-icons-outlined' >chevron_left</i>
          </span>
          <span>{currentIndex + 1} / {ads.length} Images</span>
          <span onClick={this.handleNextImage} className={css([Styles.navButton, (currentIndex === ads.length - 1) ? Styles.iconDisabled : ''])} >
            <i className='material-icons-outlined' >chevron_right</i>
          </span>
        </div>
      </div>
    )
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalContent: {
  },
  mediaContainer: {
    width: '100%',
    height: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  contentImage: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  navigation: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'space-between',
  },
  navButton: {
    border: 'none',
    color: AppTheme.primaryColor,
    cursor: 'pointer'
  },
  iconDisabled: {
    color: '#ccc',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  }
})



// WEBPACK FOOTER //
// ./src/components/SubtaskImagePreview.js